import TabPanel from "../Reusable/Tab";
import AccountingIntegration from "./AccountIntegration";
import APIIntegration from "./APIIntegration";
import EditMerchant from "./EditMerchant";
import Rate from "./Rate";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";

const SwitchTab = (props: any) => {
  const {
    profile,
    isLoading,
    handleEdit,
    openAddReceiverPopup,
    setOpenAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    branchContactData,
    cityContactData,
    currentClient,
    handleUpdateContact,
  } = props;
  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update", "API Key", "Rate", "Documents", "Accounting"]}
          tabPanels={[
            <>
              <EditMerchant
                profile={profile}
                isLoading={isLoading}
                handleEdit={handleEdit}
                openAddReceiverPopup={openAddReceiverPopup}
                setOpenAddReceiverPopup={setOpenAddReceiverPopup}
                openAddSenderPopup={openAddSenderPopup}
                setOpenAddSenderPopup={setOpenAddSenderPopup}
              />
            </>,
            <>
              <APIIntegration profile={profile} />
            </>,
            <>
              <Rate
                profile={profile}
                cityContactData={cityContactData}
                currentClient={currentClient}
                branchContactData={branchContactData}
                handleUpdateContact={handleUpdateContact}
              />
            </>,

            <>
              <FileUpload object_id={profile?.user} />
            </>,
            <>
              <AccountingIntegration profile={profile} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default SwitchTab;
